export default {
  en: {
    NonLoginAlertModal: {
      title: 'Add to Favorites',
      text: 'By registering as a member, you can register and edit your favorite pages.We also provide other useful functions and services.',
      create: 'Create Account',
      already: 'Already have an account?'
    }
  },
  'zh-hant': {
    NonLoginAlertModal: {
      title: '收藏',
      text: '註冊成為會員將可以收藏您感興趣的頁面。我們也將提供您更豐富的功能和服務支援。',
      create: '創建帳號',
      already: '已有註冊帳號'
    }
  },
  ja: {
    NonLoginAlertModal: {
      title: 'お気に入りに追加',
      text: '会員登録をすることで、お気に入りのページを登録・編集することができます。その他にも便利な機能やサービスを提供しています。',
      create: 'アカウントを作成する',
      already: 'すでにアカウントをお持ちですか？'
    }
  },
  es: {
    NonLoginAlertModal: {
      title: 'Añadir a favor',
      text: 'Al registrarse como miembro, puede registrar y editar sus páginas favoritas. También proporcionamos otras funciones y servicios útiles.',
      create: 'Crear cuenta',
      already: '¿Ya tienes una cuenta?'
    }
  },
  'pt-br': {
    NonLoginAlertModal: {
      title: 'Adicionar aos favoritos',
      text: 'Ao registrar-se como membro, você pode inserir e editar suas páginas favoritas. Também disponiblizamos outras funções e serviços.',
      create: 'Crie uma conta',
      already: 'Já tem uma conta?'
    }
  }
}
